import React, { useEffect, useState, useCallback } from "react";
import { RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import LoadingIndicator from "../../utils/LoadingIndicator";
import classes from "./style.module.scss";
import bxs_user from "../../asset/bxs_user.png";
import thumps_up_filled from "../../asset/carbon_thumbs-up-filled.png";
import thumps_up_double_filled from "../../asset/carbon_thumbs-up-double-filled.png";
import thumps_down_filled from "../../asset/carbon_thumbs-down-filled.png";
import ProviderCardModal from "./ProviderCardModal";
import {
  getUsersActivity,
  getUserActivity,
  getProviderDataByNPI,
} from "../../redux/ducks/provider";

const STAGGER_CAP = 6;

const ActivityFeeds = () => {
  const dispatch = useDispatch();
  const { usersActivity, isLoading } = useSelector((state) => state.provider);
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [activeFilter, setActiveFilter] = useState(1);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    dispatch(getUsersActivity());
  }, [dispatch]);

  // Handle Button Click (Switch Between "My Activity" and "All Activity")
  const handleFilterClick = (filter) => {
    if (filter === "1") {
      dispatch(getUsersActivity());
    } else {
      dispatch(getUserActivity());
    }
    setActiveFilter(filter);
  };

  const getClassName = (item) => {
    if (item?.modusScore >= 60 && item?.procedureCount >= 2000)
      return "modus_safetfy_color_green";
    else if (item?.procedureCount < 2000) return "modus_safetfy_color_gray";
    else if (
      item?.modusScore >= 30 &&
      item?.modusScore <= 59 &&
      item?.procedureCount >= 2000
    )
      return "modus_safetfy_color_yellow";
    else return "modus_safetfy_color_red";
  };

  const handleDoctorClick = useCallback(
    (doctor) => {
      dispatch(getProviderDataByNPI(doctor.npi));
      setSelectedDoctor(doctor);
      setModalOpen(true);
    },
    [selectedDoctor]
  );

  return (
    <div className={classes["activity-container"]}>
      <div className={classes["filter-container"]}>
        <RadioGroup
          row
          value={activeFilter}
          onChange={(e) => handleFilterClick(e.target.value)}
          className={classes["segmented"]}
        >
          <FormControlLabel
            value="0"
            className={`${classes["segment"]} ${
              activeFilter === "0" ? classes["segment-active"] : ""
            }`}
            control={<Radio className={classes["segment-radio"]} />}
            label="My Activity"
          />
          <FormControlLabel
            value="1"
            className={`${classes["segment"]} ${
              activeFilter === "1" ? classes["segment-active"] : ""
            }`}
            control={<Radio className={classes["segment-radio"]} />}
            label="All Activity"
          />
        </RadioGroup>
      </div>

      {isLoading && <LoadingIndicator fullScreen={false} />}

      {!isLoading && usersActivity.length > 0 ? (
        <div key={activeFilter}>
        {usersActivity.map((activity, idx) => (
          <div
            key={idx}
            className={classes["activity-card"]}
            style={{ "--i": Math.min(idx, STAGGER_CAP) }}
          >
            <div className={classes["user-section"]}>
              <img
                src={bxs_user}
                alt="User Avatar"
                className={classes["user-avatar"]}
              />
              <div className={classes["doctor-meta"]}>
                <h4 className={classes["doctor-name"]}>{activity?.addedBy}</h4>
                <p>{activity.roleName}</p>
              </div>
              <div className={classes["activity-added-date"]}>
                <span>
                  {activity?.commentAddedDate
                    ? activity?.commentAddedDate
                    : activity?.feedBackAddedDate}
                </span>
              </div>
            </div>

            {activity.feedbackType && (
              <div className={classes["feedback"]}>
                <img
                  alt="image for the feedback"
                  src={
                    activity.feedbackType === 1
                      ? thumps_down_filled
                      : activity.feedbackType === 2
                      ? thumps_up_filled
                      : thumps_up_double_filled
                  }
                />
                {activity.feedbackType === 1
                  ? "Disagree"
                  : activity.feedbackType === 2
                  ? "Agree"
                  : "Definitely Agree"}
              </div>
            )}

            {activity.notes && (
              <div className={classes["feedback-notes"]}>
                <p className={classes["notes"]}>{activity?.notes}</p>
              </div>
            )}

            <div className={classes["doctor-details"]}>
              <div className={classes[getClassName(usersActivity)]}>
                <span>{Math.floor(activity?.modusScore)}</span>
              </div>
              <div className={classes["doctor-name"]}>
                <button onClick={() => handleDoctorClick(activity)}>
                  <strong>{activity.doctorName}</strong>
                </button>
                <p>{activity.shortAddress}</p>
              </div>
              <div className={classes["doctor-activity"]}>
                <strong>{activity.specialty}</strong>
                <p className={classes["billing-activity"]}>
                  Billing Activity <strong>{activity.billingActivity}</strong>
                </p>
              </div>
            </div>
          </div>
        ))}
        </div>
      ) : (
        !isLoading && (
          <div className={classes["empty-state"]}>
            <svg
              width="34"
              height="34"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
            </svg>
            <p>No activity yet</p>
          </div>
        )
      )}
      {modalOpen && (
        <ProviderCardModal
          open={modalOpen}
          doctor={selectedDoctor}
          onClose={() => setModalOpen(false)}
        />
      )}
    </div>
  );
};

// Styles

export default ActivityFeeds;